import { useCallback } from 'react';
import { Icon } from '@treezor/design-system';

import { MAX_VISIBLE_RENDERED_VALUES } from '@/hooks/useDashboardConstants';

export interface IRenderSelectedValuesProps {
  label?: string;
  values?: string[];
  onReset?: () => void;
  testId?: string;
}

export function RenderSelectedValues({ label, values = [], onReset, testId }: IRenderSelectedValuesProps) {
  const getRenderedLabel = useCallback(() => {
    if (values.length === 1) return values[0];
    if (values.length > 1 && values.length <= MAX_VISIBLE_RENDERED_VALUES) return values.join(', ');
    if (values.length > MAX_VISIBLE_RENDERED_VALUES) {
      return `${[...values].splice(0, MAX_VISIBLE_RENDERED_VALUES).join(', ')} ...`;
    }
  }, [values]);

  return (
    <div className="flex justify-start items-center gap-3 whitespace-nowrap" data-testid={testId}>
      {label && <span className="typo-button-s">{label}</span>}
      {values.length > 0 && (
        <>
          <span className="typo-body-regular-small">{getRenderedLabel()}</span>
          {!!onReset && (
            <span className="block h-[14px]" onClick={onReset}>
              <Icon name="close" size="xs" />
            </span>
          )}
        </>
      )}
    </div>
  );
}
